import { useMemo } from 'react'

export const useAdminNavigationSlice = <
  TSection,
  TSetSection,
  TSelectedUserId,
  TSetSelectedUserId,
  TSelectedShopProductId,
  TSetSelectedShopProductId,
>({
  section,
  setSection,
  selectedUserId,
  setSelectedUserId,
  selectedShopProductId,
  setSelectedShopProductId,
}: {
  section: TSection
  setSection: TSetSection
  selectedUserId: TSelectedUserId
  setSelectedUserId: TSetSelectedUserId
  selectedShopProductId: TSelectedShopProductId
  setSelectedShopProductId: TSetSelectedShopProductId
}) =>
  useMemo(
    () => ({
      section,
      setSection,
      selectedUserId,
      setSelectedUserId,
      selectedShopProductId,
      setSelectedShopProductId,
    }),
    [section, selectedShopProductId, selectedUserId, setSection, setSelectedShopProductId, setSelectedUserId],
  )
